import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

import moment from "moment";
import { momentDateFormat}  from "../../../config.js";

// import { pointerStyle }  from "../../styles.js";

import {  } from "../../components/Icons.jsx";
import AuditStoreStatusLabel from "../../components/AuditStoreStatusLabel.jsx";
import { getAuditStoreStatus } from "../../utils.js";
import DateField from "../../components/DateField.jsx";
import Loading from "../../components/Loading.jsx";

import Jumbotron from "../../components/Jumbotron.jsx";

import { findActiveClients } from "../service/client.js";
import { findPending, findCompleted, navigateToReport } from "../service/audit_store.js";

import AuditorNameDisplay from "./AuditorNameDisplay.jsx";
import "../../../css/bs_overrides.scss";

// react-router v6 location objects carry a raw query string (.search) rather than v3's parsed .query object.
const getQueryType = (location) => new URLSearchParams(location.search).get("type");

class AuditStoreList2 extends Component{
	static propTypes = {
		auditStores: PropTypes.array,
		client: PropTypes.object,
		qaType: PropTypes.string,
	};

	constructor(props){
		super(props);
		this.state = {
		};
	}

	// openReportNewTab(id) {
	// 	let url = `/static/moderator#/audit_store/${id}/report`;
	// 	window.open(url);
	// }
	navigateToReportPage = (as) =>{
		if(as.status==="SUBMITTED" && as.moderator_submission_time===null){
			const payload = [{
				audit_store_id : as.id,
				moderator_submission_time : "00:00:00"
			}];
			let promise = navigateToReport(payload);
			promise.then(()=>{
				window.open(`/#/audit_store/${as.id}/report`, "_blank");
			});
		}else{
			window.open(`/#/audit_store/${as.id}/report`, "_blank");
		}
	};

	render(){
		let reps = [];
		for(let as of this.props.auditStores){
			reps.push( <tr key={as.id} style={(as.critical_report===true && as.critical_status===false && as.status==="SUBMITTED") ? {backgroundColor:"#f2dede"}:{backgroundColor:""}}>
				{/* <tr key={as.id} style={pointerStyle} onClick={() => hashHistory.push(`/audit_store/${as.id}/report`)}> */}
				<td className="text-right">{as.id}</td>
				{/* <td>{as.audit.audit_cycle.client.name}</td> */}
				{/* <td className="cycle-name-cell" title={as.audit.audit_cycle.name}>{as.audit.audit_cycle.name}</td> */}
				<td>{as.audit.audit_cycle.name}</td>
				<td>{as.audit.store.name}, {as.audit.store.city.name}</td>
				<td><AuditorNameDisplay user={as.user}/></td>
				<td className="text-right">{as.audit.earnings_per_audit}</td>
				<td className="text-right">{as.audit.reimbursement}</td>
				<td>{as.audit.store.city.name}</td>
				<td>{moment(as.audit_date).format(momentDateFormat)}</td>
				{this.props.qaType === "qa_done" && <td>{moment(as.moderator_submission_date).format(momentDateFormat)}</td>}
				<td>
					<tr>
						<AuditStoreStatusLabel status={as.status}/> {as.report_revert_count>0 ? <span><i>Reverted({as.report_revert_count})</i></span>:null}
					</tr>
					<tr>
						<td colSpan="10">
							<div style={{marginTop:"4px"}}>
								<i>{as.auto_assigned ? <span><i>(Auto Assigned)</i></span> : null }{as.instant_assigned ? <span><i>(Instant Assigned)</i></span> : null}</i>
							</div>
						</td>
					</tr>
				</td>
				{/* <td>
					<Link to={`/audit_store/${as.id}/report`} target="_blank" className="btn btn-default">View</Link>
				</td> */}
				<td>
					<p className="btn btn-default" onClick={()=>this.navigateToReportPage(as)}>View</p>
				</td>
			</tr>);
		}

		if(reps.length === 0){
			return <Jumbotron key="empty" heading="there are no reports here" para="assigned reports will be visible here"/>;
		}
		return(
			<div className="panel panel-default table-responsive">
				<div className="panel-heading">
					<h4 className="">{this.props.auditStores[0] && this.props.auditStores[0].audit.audit_cycle.client.name} - {this.props.auditStores.length} Reports</h4>
				</div>
				<table className="table table-hover table-striped">
					<thead>
						<tr>
							<th className="text-right">Report ID</th>
							{/* <th>Client</th> */}
							<th>Cycle Name</th>
							<th>Store</th>
							<th>Auditor Name</th>
							<th className="text-right">Fees</th>
							<th className="text-right">Reimbursement</th>
							<th>City</th>
							<th>Audit Date</th>
							{this.props.qaType === "qa_done" && <th>Moderator Submition Date</th>}
							<th>Report Status</th>
							<th></th>
						</tr>
					</thead>
					<tbody>
						{reps}
					</tbody>
				</table>
			</div>
		);
	}
}

class AuditStoreTables extends Component {
	static propTypes = {
		auditStores: PropTypes.array,
		qaType: PropTypes.string,
	};

	render(){
		let client_dict = {};
		for(let as of this.props.auditStores){
			if(!client_dict[as.audit.audit_cycle.client.id]){
				client_dict[as.audit.audit_cycle.client.id] = [];
			}
			client_dict[as.audit.audit_cycle.client.id].push(as);
		}

		let tables = [];
		for(let client_id in client_dict){
			tables.push(<AuditStoreList2 key={client_id} auditStores={client_dict[client_id]} qaType={this.props.qaType}/>);
		}
		return (<div className="container">
			<h2 className="page-header">{this.props.auditStores.length} Reports</h2>
			{tables}
		</div>);
	}
}

export default class AuditStoreDashboard extends Component {
	static propTypes = {
		location: PropTypes.object,
	};

	constructor(props){
		super(props);
		const currentMonth = moment().month() + 1;
		const currentYear = moment().format("YYYY");
		this.state = {
			clients: [],
			qa_pending: [],
			qa_done: [],
			client: "",
			totalAuditStoreCount: 0,
			loading: false,
			loadMoreLoader: false,
			filterStatus: "",
			month: currentMonth,
			year: currentYear,
			auditDate: "",
			startDate: "",
			endDate: "",
		};
	}

	setLoading = (loading) => {
		this.setState(prevState => Object.assign({}, prevState, {loading}));
	};

	componentDidMount(){
		this.setLoading(true);
		let lastAuditStoreDate = "";
		findActiveClients().then((clients)=>this.setState({clients}));
		if(getQueryType(this.props.location) === "qa_done"){
			findCompleted(lastAuditStoreDate, this.state.filterStatus, this.state.client, this.state.month, this.state.year,  this.state.auditDate).then(auditStores => this.setState({qa_done: auditStores["auditStores"], totalAuditStoreCount: auditStores["count"]})).always(() => this.setLoading(false));
		} else {
			findPending(lastAuditStoreDate, this.state.filterStatus, this.state.client,  this.state.startDate, this.state.endDate).then(auditStores => this.setState({qa_pending: auditStores["auditStores"], totalAuditStoreCount: auditStores["count"]})).always(() => this.setLoading(false));
		}
	}

	componentDidUpdate(prevProps){
		if(getQueryType(prevProps.location) !== getQueryType(this.props.location)){
			const currentMonth = moment().month() + 1;
			const currentYear = moment().format("YYYY");
			this.setState({
				filterStatus: "",
				client: "",
				auditDate: "",
				startDate: "",
				endDate: "",
				month: currentMonth,
				year: currentYear
			});
			this.setLoading(true);
			let lastAuditStoreDate = "";
			if( getQueryType(this.props.location) === "qa_done"){
				findCompleted(lastAuditStoreDate, "", "", currentMonth, currentYear, "").then(auditStores => this.setState({qa_done: auditStores["auditStores"], totalAuditStoreCount: auditStores["count"]})).always(() => this.setLoading(false));
			} else {
				findPending(lastAuditStoreDate, "", "", "").then(auditStores => this.setState({qa_pending: auditStores["auditStores"], totalAuditStoreCount: auditStores["count"]})).always(() => this.setLoading(false));
			}
		}
	}

	statusChanged(e, qa_type){
		this.setState({
			filterStatus: e.target.value
		});
		this.setLoading(true);
		let lastAuditStoreDate = "";
		if(qa_type === "qa_done"){
			findCompleted(lastAuditStoreDate, e.target.value, this.state.client, this.state.month, this.state.year, this.state.auditDate).then(auditStores => this.setState({qa_done: auditStores["auditStores"], totalAuditStoreCount: auditStores["count"]})).always(() => this.setLoading(false));
		}
		else{
			findPending(lastAuditStoreDate, e.target.value, this.state.client, this.state.startDate, this.state.endDate).then(auditStores => this.setState({qa_pending: auditStores["auditStores"], totalAuditStoreCount: auditStores["count"]})).always(() => this.setLoading(false));
		}
	}

	clientChanged = (e, qa_type) =>{
		let client_id = e.target.value;
		if(client_id){
			this.setState({
				client: client_id
			});
		}
		else{
			this.setState({
				client: ""
			});
		}
		this.setLoading(true);
		let lastAuditStoreDate = "";
		if(qa_type === "qa_done"){
			findCompleted(lastAuditStoreDate, this.state.filterStatus, e.target.value, this.state.month, this.state.year, this.state.auditDate).then(auditStores => this.setState({qa_done: auditStores["auditStores"], totalAuditStoreCount: auditStores["count"]})).always(() => this.setLoading(false));
		}
		else{
			findPending(lastAuditStoreDate, this.state.filterStatus, e.target.value, this.state.startDate, this.state.endDate).then(auditStores => this.setState({qa_pending: auditStores["auditStores"], totalAuditStoreCount: auditStores["count"]})).always(() => this.setLoading(false));
		}
	};

	dateChanged = (date, qa_type) => {
		// DateField passes "YYYY-MM-DD", or "" when cleared.
		let formattedDate = date || "";
		let newMonth = formattedDate ? "" : (moment().month() + 1);
		let newYear = formattedDate ? "" : moment().format("YYYY");
		this.setState({
			auditDate: formattedDate,
			month: newMonth,
			year: newYear

		});
		this.setLoading(true);
		let lastAuditStoreDate = "";
		if(qa_type === "qa_done"){
			findCompleted(lastAuditStoreDate, this.state.filterStatus, this.state.client, newMonth, newYear, formattedDate).then(auditStores => this.setState({qa_done: auditStores["auditStores"], totalAuditStoreCount: auditStores["count"]})).always(() => this.setLoading(false));
		}
		// else{
		// 	findPending(lastAuditStoreDate, this.state.filterStatus, this.state.client, formattedDate).then(auditStores => this.setState({qa_pending: auditStores["auditStores"], totalAuditStoreCount: auditStores["count"]})).always(() => this.setLoading(false));
		// }
	};

	clearAuditDate = (qa_type) => {
		const currentMonth = moment().month() + 1;
		const currentYear = moment().format("YYYY");
		this.setState({
			auditDate: "",
			month: currentMonth,
			year: currentYear
		});
		this.setLoading(true);
		let lastAuditStoreDate = "";
		if(qa_type === "qa_done"){
			findCompleted(lastAuditStoreDate, this.state.filterStatus, this.state.client, currentMonth, currentYear, "").then(auditStores => this.setState({qa_done: auditStores["auditStores"], totalAuditStoreCount: auditStores["count"]})).always(() => this.setLoading(false));
		}
		// else{
		// 	findPending(lastAuditStoreDate, this.state.filterStatus, this.state.client, "").then(auditStores => this.setState({qa_pending: auditStores["auditStores"], totalAuditStoreCount: auditStores["count"]})).always(() => this.setLoading(false));
		// }
	};

	startDateChanged = (date) => {
		const formattedDate = date || ""; // DateField passes "YYYY-MM-DD" or ""

		this.setState({
			startDate: formattedDate
		});
	};

	endDateChanged = (date) => {
		const formattedDate = date || ""; // DateField passes "YYYY-MM-DD" or ""

		this.setState({
			endDate: formattedDate
		});
	};

	findFilter = () => {
		const {
			filterStatus,
			client,
			startDate,
			endDate
		} = this.state;

		if (!startDate || !endDate) {
			alert("Please select both Start Date and End Date");
			return;
		}

		this.setLoading(true);

		let lastAuditStoreDate = "";

		findPending(lastAuditStoreDate, filterStatus, client, startDate, endDate).then(auditStores =>this.setState({qa_pending: auditStores.auditStores,totalAuditStoreCount: auditStores.count})).always(() => this.setLoading(false));
	};

	findClearFilter = () => {
		this.setState({
			filterStatus: "",
			client: "",
			startDate: "",
			endDate: ""
		});
		findPending("","","","","").then(auditStores =>this.setState({qa_pending: auditStores.auditStores,totalAuditStoreCount: auditStores.count})).always(() => this.setLoading(false));
	};

	fetchData = (qa_type) => {
		this.setLoading(true);
		let lastAuditStoreDate = "";

		if(qa_type === "qa_done"){
			findCompleted(
				lastAuditStoreDate,
				this.state.filterStatus,
				this.state.client,
				this.state.month,
				this.state.year,
				this.state.auditDate
			).then(auditStores =>
				this.setState({
					qa_done: auditStores["auditStores"],
					totalAuditStoreCount: auditStores["count"]
				})
			).always(() => this.setLoading(false));
		}
		else{
			findPending(
				lastAuditStoreDate,
				this.state.filterStatus,
				this.state.client,
				this.state.startDate,
				this.state.endDate
			).then(auditStores =>
				this.setState({
					qa_pending: auditStores["auditStores"],
					totalAuditStoreCount: auditStores["count"]
				})
			).always(() => this.setLoading(false));
		}
	};
	monthChanged = (e, qa_type) => {
		this.setState({ month: e.target.value, auditDate: "" }, () => {
			this.fetchData(qa_type);
		});
	};

	yearChanged = (e, qa_type) => {
		this.setState({ year: e.target.value, auditDate: "" }, () => {
			this.fetchData(qa_type);
		});
	};
	loadMore(qa_type){
		this.setState({
			loadMoreLoader: true
		});
		if(qa_type === "qa_done"){
			let lastAuditStoreDate = this.state.qa_done[this.state.qa_done.length-1].audit_date;
			findCompleted(lastAuditStoreDate, this.state.filterStatus, this.state.client, this.state.month, this.state.year, this.state.auditDate).then((auditStores) => {
				let newAuditStores = this.state.qa_done;
				for(let reports of auditStores.auditStores){
					let check_report = this.state.qa_done.filter(function(report){ return (report.id === reports.id); });
					if(check_report.length === 0){
						newAuditStores.push(reports);
					}
				}
				this.setState({
					qa_done: newAuditStores,
					loadMoreLoader: false
				});
			});
		}
		else{
			let lastAuditStoreDate = this.state.qa_pending[this.state.qa_pending.length-1].audit_date;
			findPending(lastAuditStoreDate, this.state.filterStatus, this.state.client, this.state.startDate, this.state.endDate).then((auditStores) => {
				let newAuditStores = this.state.qa_pending;
				for(let reports of auditStores.auditStores){
					let check_report = this.state.qa_pending.filter(function(report){ return (report.id === reports.id); });
					if(check_report.length === 0){
						newAuditStores.push(reports);
					}
				}
				this.setState({
					qa_pending: newAuditStores,
					loadMoreLoader: false
				});
			});
		}
	}

	render(){
		if(this.state.loading){
			return <Loading/>;
		}
		let loadMoreLoading;
		if(this.state.loadMoreLoader){
			loadMoreLoading = (<Loading/>);
		}
		const client_option_list = this.state.clients.map((value, index)=><option key={index} value={value.id}>{value.name}</option>);

		let statusFilter;
		let clientFilter;
		let dateFilter;
		let monthFilter;
		let yearFilter;
		if(getQueryType(this.props.location) === "qa_done"){
			let loadMoreButton;
			if(this.state.qa_done.length !== this.state.totalAuditStoreCount){
				loadMoreButton = (<center><button className="btn btn-default" onClick={() => this.loadMore("qa_done")}>Load More</button></center>);
			}
			statusFilter = (
				<select className="form-control" style={{display:"inline-block", width:"200px", marginBottom:"1rem"}} value={this.state.filterStatus} onChange={(e) => this.statusChanged(e, "qa_done")}>
					<option value="">All Status</option>
					<option value="PM_REVIEW">{getAuditStoreStatus("PM_REVIEW")}</option>
					<option value="COMPLETED">{getAuditStoreStatus("COMPLETED")}</option>
					<option value="FAILED">{getAuditStoreStatus("FAILED")}</option>
					<option value="ACCEPTED">{getAuditStoreStatus("ACCEPTED")}</option>
					<option value="REJECTED">{getAuditStoreStatus("REJECTED")}</option>
				</select>
			);
			clientFilter = (
				<select className="form-control" style={{display:"inline-block", width:"200px", marginBottom:"1rem"}} value={this.state.client} onChange={(e) => this.clientChanged(e, "qa_done")}>
					<option value="">Select client</option>
					{client_option_list}
				</select>
			);
			dateFilter = (
				<span style={{position:"relative", display:"inline-flex", width:"200px"}}>
					<DateField
						value={this.state.auditDate}
						onChange={(date) => this.dateChanged(date, "qa_done")}
						placeholder="Audit Date"
						suffixIcon={this.state.auditDate ? null : undefined}
					/>
					{this.state.auditDate && (
						<span
							style={{
								position:"absolute",
								right:"10px",
								top:"50%",
								transform:"translateY(-50%)",
								cursor:"pointer",
								color:"#999",
								fontSize:"16px",
								lineHeight:"1",
								userSelect:"none",
								zIndex:2
							}}
							onClick={() => this.clearAuditDate("qa_done")}
							title="Clear date"
						>
							&times;
						</span>
					)}
				</span>
			);
			monthFilter = (
				<select
					className="form-control"
					style={{display:"inline-block", width:"180px"}}
					value={this.state.month}
					onChange={(e) => this.monthChanged(e, "qa_done")}
				>
					<option value="">-- Month --</option>
					{moment.months().map((m, index) => (
						<option key={index} value={index + 1}>
							{m}
						</option>
					))}
				</select>
			);

			yearFilter = (
				<select
					className="form-control"
					style={{display:"inline-block", width:"120px"}}
					value={this.state.year}
					onChange={(e) => this.yearChanged(e, "qa_done")}
				>
					<option value="">-- Year --</option>
					{[...Array(5)].map((_, i) => {
						const year = moment().year() - i;
						return <option key={year} value={year}>{year}</option>;
					})}
				</select>
			);
			return (
				<div>
					<div style={{display:"flex",justifyContent:"center",alignItems:"center",flexWrap:"wrap"}}>
						<label>Status Filter : </label> &nbsp;
						{statusFilter} &nbsp;
						<label>Client Filter : </label> &nbsp;
						{clientFilter} &nbsp;
						&nbsp;
						<label>Audit Date : </label> &nbsp;
						<span style={{display:"inline-block", width:"200px"}}>{dateFilter}</span>
						&nbsp; &nbsp;
						<label>Month : </label> &nbsp;
						{monthFilter} &nbsp;
						<label>Year : </label> &nbsp;
						{yearFilter}
					</div>
					<AuditStoreTables auditStores={this.state.qa_done} qaType="qa_done"/>
					{loadMoreButton}
					{loadMoreLoading}
				</div>
			);
		} else {
			let loadMoreButton;
			if(this.state.qa_pending.length !== this.state.totalAuditStoreCount){
				loadMoreButton = (<center><button className="btn btn-default" onClick={() => this.loadMore("qa_pending")}>Load More</button></center>);
			}
			statusFilter = (
				<select className="form-control" style={{display:"inline-block", width:"200px"}} value={this.state.filterStatus} onChange={(e) => this.statusChanged(e, "qa_pending")}>
					<option value="">All Status</option>
					<option value="ASSIGNED">{getAuditStoreStatus("ASSIGNED")}</option>
					<option value="ACKNOWLEDGED">{getAuditStoreStatus("ACKNOWLEDGED")}</option>
					<option value="SUBMITTED">{getAuditStoreStatus("SUBMITTED")}</option>
					<option value="CRITICAL_REPORT">{getAuditStoreStatus("CRITICAL_REPORT")}</option>
					<option value="REVERTED_REPORT">{getAuditStoreStatus("REVERTED_REPORT")}</option>
				</select>
			);
			clientFilter = (
				<select className="form-control" style={{display:"inline-block", width:"200px"}} value={this.state.client} onChange={(e) => this.clientChanged(e, "qa_pending")}>
					<option value="">Select client</option>
					{client_option_list}
				</select>
			);
			dateFilter = (
				<span style={{position:"relative", display:"inline-flex", width:"200px"}}>
					<DateField
						value={this.state.auditDate}
						onChange={(date) => this.dateChanged(date, "qa_pending")}
						placeholder="Audit Date"
						suffixIcon={this.state.auditDate ? null : undefined}
					/>
					{this.state.auditDate && (
						<span
							style={{
								position:"absolute",
								right:"10px",
								top:"50%",
								transform:"translateY(-50%)",
								cursor:"pointer",
								color:"#999",
								fontSize:"16px",
								lineHeight:"1",
								userSelect:"none",
								zIndex:2
							}}
							onClick={() => this.clearAuditDate("qa_pending")}
							title="Clear date"
						>
							&times;
						</span>
					)}
				</span>
			);
			return (
				<div>
					<div style={{display:"flex",justifyContent:"center",alignItems:"center",flexWrap:"wrap"}}>
						<label>Status Filter : </label> &nbsp;
						{statusFilter} &nbsp;
						<label>Client Filter : </label> &nbsp;
						{clientFilter}  &nbsp;
						<label>Start Date :</label>&nbsp;
						<span style={{display:"inline-block", width:"200px"}}>
							<DateField
								value={this.state.startDate}
								onChange={this.startDateChanged}
								placeholder="Start Date"
								allowClear
							/>
						</span>

						&nbsp;&nbsp;

						<label>End Date :</label>&nbsp;
						<span style={{display:"inline-block", width:"200px"}}>
							<DateField
								value={this.state.endDate}
								onChange={this.endDateChanged}
								placeholder="End Date"
								allowClear
							/>
						</span>

						&nbsp;&nbsp;

						<button
							className="btn btn-primary"
							onClick={this.findFilter}
						>
							Find
						</button>
						&nbsp;&nbsp;
						<button
							className="btn btn-primary"
							onClick={this.findClearFilter}
						>
							Clear
						</button>
					</div>
					<AuditStoreTables auditStores={this.state.qa_pending} qaType="qa_pending"/>
					{loadMoreButton}
					{loadMoreLoading}
				</div>
			);
		}
	}
}
